<template>
    <div class="tab-area">
        <form @submit.prevent="signIn">
            <vue-form-generator :schema="schema" :model="model" :options="config.formOptions"></vue-form-generator>
            <button class="btn green-btn" type="submit">Sign in</button>
        </form>
    </div>
</template>

<script>

    import config from "../modules/config";

    import VueFormGenerator from 'vue-form-generator';

    export default {
        data () {
            return {
                config: config,
                model: {
                    username: null,
                    password: null,
                },
                schema: {
                    fields: [
                        {
                            type:  'input',
                            label: 'E-mail',
                            model: 'username',
                            inputType: 'email',
                            required: true,
                            placeholder: 'e-mail address',
                            validator: VueFormGenerator.validators.email
                        },
                        {
                            type:  'input',
                            label: 'Password',
                            model: 'password',
                            inputType: 'password',
                            required: true,
                            placeholder: '******',
                            validator: VueFormGenerator.validators.string
                        },
                    ]
                }
            }
        },
        metaInfo: {
            title: 'Sign in to TreasureHunter',
        },
        methods: {
            signIn() {

                const self = this;

                const {username, password} = self.model;

                self.$store.commit('showLoading');

                self.$store.dispatch('users/AUTH_REQUEST', {username, password}).then(() => {
                    self.$store.dispatch('clear');
                    self.$router.push({name: 'dashboard'});
                });

                return false;
            },
        }
    }
</script>